import { render, staticRenderFns } from "./postingQueue.vue?vue&type=template&id=c3125450"
import script from "./postingQueue.vue?vue&type=script&lang=js"
export * from "./postingQueue.vue?vue&type=script&lang=js"
import style0 from "./postingQueue.vue?vue&type=style&index=0&id=c3125450&prod&tyle=text%2Fcss&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports